<template>
  <div class="textbox" ref="main" @click="switchopen" :style="{'white-space': Open?'normal':'nowrap', 'width': `${width-20}px`}">
    <span class="text" ref="text" :style="{'display':'inline-block'}">{{ text }}</span>
    <div class="icon" ref="icon" v-if="showicon">
      <i class="el-icon-caret-bottom" v-show="!Open" />
      <i class="el-icon-caret-top" v-show="Open" />
    </div>
  </div>
</template>
<script type="es6">
import eventBus from '@/utils/eventBus';
export default {
  data () {
    return {
      showicon: false,
      Open: false,
      width: 215
    };
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    switchFlg: {
      type: Boolean
    }
  },
  components: {},
  computed: {
  },
  methods: {
    showiconju () {
      setTimeout(() => {
        if (!this.$refs.main || !this.$refs.text) {
          this.showicon = false;
          return;
        }
        // 右侧三角的偏移量
        // console.log('this.width = this.$refs.main.parentElement',this.$refs.main.parentElement.clientWidth)
        // this.width = this.$refs.main.parentElement.offsetWidth ;
        if (this.$refs.main.parentElement.offsetWidth < 350) {
          this.width = this.$refs.main.parentElement.offsetWidth;
        } else {
          this.width = 350;
        }
        this.$refs.text.style.display = 'inline-block';
        this.$nextTick(() => {
          // console.log('this.$refs.text.offsetWidth',this.$refs.text.offsetWidth)
          if (this.$refs.text.offsetWidth >= this.width - 31) {
            this.showicon = true;
            this.$refs.text.style.display = 'inline';
            this.Open = !this.switchFlg;
          } else {
            this.showicon = false;
            this.$refs.text.style.display = 'inline-block';
          }
        });
      }, 50);
    },
    switchopen () {
      if (this.showicon) {
        this.Open = !this.Open;
      }
    },
    expandDisc () {
      this.Open = this.switchFlg;
    }
  },
  watch: {
    text: function () {
      this.showiconju();
    }
  },
  mounted () {
    this.showiconju();
    eventBus.$on('longTextDisc', () => {
      this.expandDisc();
    });
    eventBus.$on('initLongtext', () => {
      this.showiconju();
    });
  },
  destoryed () {
    eventBus.$off('longTextDisc');
    eventBus.$off('initLongtext');
  }
};
</script>
<style lang="scss" scoped>
  .textbox{
    width:200px;
    overflow: hidden;
    word-break: break-all;
    text-overflow: ellipsis;
    /*white-space: nowrap;*/
    position: relative;
    padding-right: 10px;
    .icon{
      position: absolute;
      right: 0;
      bottom: 0px;
      color: #606266;
    }
  }
</style>
